export default {
  reset(state) {
    state.history = [];
    state.profiles = {};
    state.fudaoDto = {};
    state.fudaoSession = {};
    state.isFudaoConnected = false;
    state.fudaoPassedTime = 0;
  },

  updateHistory(state, payload) {
    state.history = payload;
  },

  updateProfile(state, payload = {}) {
    if (!payload._id) {
      return;
    }
    state.profiles[payload._id] = payload;
  },

  /**
   *
   * @param {*} state
   * @param {*} payload profiles object. key is profile's id.
   */
  updateProfiles(state, payload = {}) {
    state.profiles = {...state.profiles, ...payload};
  },

  updateFudaoDto(state, fudaoDto) {
    state.fudaoDto = fudaoDto;
  },

  updateFudaoSession(state, fudaoSession) {
    state.fudaoSession = fudaoSession;
  }
};
